// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-container {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
}

ul.list-container {
  width: 100%;
  padding: 0 !important;
  list-style-type: none !important;
}

ul.list-container li.list-item {
  border-bottom: 1px solid #dddddd;
  width: 100%;
  display: table !important;
  padding-left: 2%;
}

.userLabel {
  margin-top: 5px;
  font-size: 12px;
  color: #b2b2b2;
  padding: 0;
}

.dateLabel {
  font-size: 12px;
  color: #b2b2b2;
  padding: 0;
}

.descriptionLabel {
  font-size: 12px;
  color: var(--theme-main-color, #055C8D);
  padding: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
